import { render, staticRenderFns } from "./EditFolderModal.vue?vue&type=template&id=ce34fe94&"
import script from "./EditFolderModal.vue?vue&type=script&lang=js&"
export * from "./EditFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFolderModal.vue?vue&type=style&index=0&id=ce34fe94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports